<ng-container *ngFor="let sellerMapItem of sellerMap; let i = index;">
  <ng-container *ngIf="sellerMapItem?.sellers?.length > 0">
    <div class="row">
      <div class="col-lg-12">
        <div class="container-fluid pt-4 pl-0 info-list has-info-icon height-unset sellers-cont">
          <h3 class="sub-title">
            {{sellerMapItem.paymentType === 'N/A' ? 'Unauthorized' : sellerMapItem.paymentType}}
            <ng-container *ngIf="sellerMapItem.paymentType !== 'Resellers'">Sellers </ng-container>
            <a class="btn btn-link help-icon p-0" data-toggle="tooltip"
              [attr.title]="tooltipMapping[sellerMapItem.paymentType]">
              <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
            </a>
          </h3>
        </div>
      </div>
    </div>
    <div *ngIf="!isFreemium && sellerMapItem?.chartData?.length > 0">
      <app-pie-chart [data]="sellerMapItem?.chartData" [colors]="colorMapping[sellerMapItem.paymentType]"></app-pie-chart>
    </div>
    <div class="freemium-lock mb-4 ml-3" *ngIf="isFreemium">
      <i class="fa fa-lock"></i>
    </div>
    <app-data-table-component [headers]="headers"
                              [subHeaders]="subHeaders"
                              [subDataTables]="subDataTables"
                              [id]="sellerMapItem.paymentType === 'N/A' ? 'Unauthorized' : sellerMapItem.paymentType"
                              [currentSort]="'paymentType'"
                              [data]="sellerMapItem?.sellers"
                              [limit]="showMoreLimit" minWidth="600px"
                              (itemClick)="goTo($event)"
    ></app-data-table-component>
  </ng-container>
</ng-container>
<app-follow-unlock label="Additional Sellers and Metrics" (followClick)="follow()" *ngIf="!isFollowing && isFreemium">
</app-follow-unlock>

<ng-template #sellerNameTemplate let-item='item' let-row='row'>
  <div class="d-flex white-space-nowrap">
    <ng-container *ngIf='item !== "Other"'>
      <img class="mr-1" src="https://cdn.pixalate.com/sellers/icons/apn/16x16/{{ row.sellerId }}.jpg" width="16"
        height="16" onerror="this.style.opacity=0;this.style.fontSize=0;" alt="{{ item }} Icon">
    </ng-container>
    <span>{{ item }}</span>
  </div>

</ng-template>
